import {useSelector} from "react-redux";
import Goal from "./goal";
import {normalizeMembershipEntity, prepareMembershipPayload} from "../workspace-membership/workspace-membership-identity";

const membershipPopulate = {populate: {member: {populate: ["profileImage"]}}};
const teamPopulate = {populate: {members: membershipPopulate, owner: membershipPopulate}};

function withGoalMembershipPopulates(query) {
    if (!query?.populate || typeof query.populate !== "object") return query;
    query.populate.owner = membershipPopulate;
    query.populate.archivedBy = membershipPopulate;
    if (query.populate.projects?.populate && !Array.isArray(query.populate.projects.populate)) {
        query.populate.projects.populate.owner = membershipPopulate;
    }
    return query;
}

export function useGoal() {
    const {workspaceMembershipData} = useSelector(state => state.app);
    const memberships = workspaceMembershipData?.workspace?.workspace_memberships || [];
    const normalizeGoal = (item) => normalizeMembershipEntity(item, "goal", memberships);
    const getGoals = async (workspaceId)=>{
        if (!workspaceId)return
        try {
            const goal = new Goal();
            let query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                        {archivedAt:{$null: true}},


                        // {
                        //     $or: [
                        //         {owner: {$eq: user.id}},
                        //         // {members: {$in: [user.id]}},
                        //         {workspace: {
                        //                 user_roles: {
                        //                     $and:[
                        //                         {user:{$eq:user.id}},
                        //                         {role:{$eq:"owner"}}
                        //                     ]
                        //                 }
                        //             }},
                        //         // {team: {members: {$in: [user.id]}}},
                        //     ]
                        // }
                    ],
                },
                populate: {
                    workspace: {fields: ["id", "documentId"]},
                    childrenGoals:true,
                    team:teamPopulate,
                    parentGoal:{
                        filters:{$and:[{archivedAt:{$null:true}}]}
                    },
                    owner: membershipPopulate,
                    projects: {
                        populate:{owner: membershipPopulate},
                        filters:{$and:[{archivedAt:{$null:true}}]},
                    },
                }
            }

            // if (!permission.can("create-new-goals")){
            //     query = query.filters.$and.push({
            //         $or:[
            //             {team:{members: {$in:[user.id]}}},
            //             {owner:{$eq: user.id}},
            //         ]
            //     })
            // }

            const _data = await goal.getAll(withGoalMembershipPopulates(query));

            return (_data.data || []).map(normalizeGoal)
        }catch (e){

        }
    }

    const getGoal = async (goalId)=>{
        try {
            const goal = new Goal();
            const query = {
                filters: {
                    $and:[
                        {archivedAt:{$null: true}},
                    ],
                },
                populate: {
                    childrenGoals:true,
                    team:true,
                    parentGoal:{
                        filters:{$and:[{archivedAt:{$null:true}}]}
                    },
                    owner: membershipPopulate,
                    projects: {
                        populate:{owner: membershipPopulate},
                        filters:{$and:[{archivedAt:{$null:true}}]},
                    },
                }
            }
            const _data = await goal.getById(goalId, withGoalMembershipPopulates(query));

            return normalizeGoal(_data.data)
        }catch (e){

        }
    }

    const updateGoal = async (goalId, goalData, options = {})=>{
        // if (!permission.can("goal.update", true))return;
        try {
            const goal = new Goal();
            const query = {
                populate: {
                    childrenGoals:true,
                    team:true,
                    parentGoal:{
                        filters:{$and:[{archivedAt:{$null:true}}]}
                    },
                    owner: membershipPopulate,
                    projects: {
                        populate:{owner: membershipPopulate},
                        filters:{$and:[{archivedAt:{$null:true}}]},
                    },
                }
            }
            const payload = prepareMembershipPayload("goal", goalData, memberships, {
                operation: "update",
                currentMembership: workspaceMembershipData,
            });
            const _data = await goal.update(goalId, payload, withGoalMembershipPopulates(query));
            return normalizeGoal(_data.data)
        }catch (e){
            if (options.throwOnError) throw e;
        }
    }

    const createGoal = async (goalData)=>{
        // if (!permission.can("goal.create", true))return;
        try {
            const goal = new Goal();
            const query = {
                populate: {
                    childrenGoals:true,
                    team:true,
                    parentGoal:{
                        filters:{$and:[{archivedAt:{$null:true}}]}
                    },
                    owner: membershipPopulate,
                    projects: {
                        populate:{owner: membershipPopulate},
                        filters:{$and:[{archivedAt:{$null:true}}]}
                    },
                }
            }
            const payload = prepareMembershipPayload("goal", goalData, memberships, {
                operation: "create",
                currentMembership: workspaceMembershipData,
            });
            const _data = await goal.create(payload, withGoalMembershipPopulates(query));
            return normalizeGoal(_data.data)
        }catch (e){
            throw e;
        }
    }


    const prepareTable = ({actions, config})=>{
        const fields=["title", "owner", "goalStatus"]//Object.keys(DeviceEntity.fields);
        const value=(item)=>{
            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <span className="pi pi-eye cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{}}/>
                    {/*<span className="pi pi-file-edit cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onEditClicked({value:item})}}/>*/}
                    {/*<span className={`pi pi-power-off cursor-pointer hover:surface-100 border-circle p-3 ${item.kphwms_isonline?"text-red-500":"text-green-500"}`} onClick={()=>{actions.onPowerOffClicked({value:item})}}/>*/}
                    {/*<span className="pi pi-sync cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{console.log(item)}}/>*/}
                    {/*<span className="pi pi-trash cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onDeleteClicked({value:item})}}/>*/}
                </div>
            )
        }
        const fieldsConfig = {
            title:{alias:"goal-title", type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            owner:{alias:"goal-owner", type:"AVATAR_GROUP", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            goalStatus:{alias:"status", type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            actions:{type:"ACTIONS", value, translate:true, "class-name":"w-3rem"},
        }
        return {fields, fieldsConfig}
    }

    const statusClassName = (status, border, bg)=>{
        switch (status) {
            case "on-way": return `${bg&&"bg-green-100"} ${border&&"border-1"} text-green-500 border-round border-green-500 p-1 px-2 w-fit text-2xs`
            case "has-risks": return `${bg&&"bg-yellow-100"} ${border&&"border-1"} text-yellow-500 border-round border-yellow-500 p-1 px-2 w-fit text-2xs`
            case "out-of-way": return `${bg&&"bg-red-100"} ${border&&"border-1"} text-red-500 border-round border-red-500 p-1 px-2 w-fit text-2xs`
            case "achieved": return `${bg&&"bg-green-100"} ${border&&"border-1"} text-green-500 border-round border-green-500 p-1 px-2 w-fit text-2xs`
            case "canceled": return `${bg&&"surface-200"} ${border&&"border-1"} text-400 border-round border-400 p-1 px-2 w-fit text-2xs`
            case "archived": return `${bg&&"bg-red-100"} ${border&&"border-1"} text-red-500 border-round border-red-500 p-1 px-2 w-fit text-2xs`
            default: return `${bg&&"surface-200"} ${border&&"border-1"} text-400 border-round border-400 p-1 px-2 w-fit text-2xs`
        }
    }

    const findGoals = async (query, options = {})=>{
        try {
            const goal = new Goal();
            const _data = await goal.getAll(withGoalMembershipPopulates(query));
            return (_data.data || []).map(normalizeGoal)
        }catch (e){
            if (options.throwOnError) throw e;
            return [];
        }
    }


    const getArchivedGoal = async (documentId) => {
        const goalModel = new Goal();

        const res = await goalModel.getById(documentId, withGoalMembershipPopulates({
            populate: {
                childrenGoals: true,
                team: true,
                parentGoal: true,
                owner: membershipPopulate,
                projects: true
            }
        }));

        return normalizeGoal(res?.data);
    };

    return {getGoals, updateGoal, createGoal, getGoal, prepareTable, statusClassName, getArchivedGoal , findGoals};
}
